import { Clock } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Botao } from '../components/ui';
import { useSessao } from '../features/auth/contexto';
import { momentoUltimaAtividade } from '../lib/api';

const INATIVIDADE_MS = 30 * 60_000; // D-016
const AVISAR_ANTES_MS = 5 * 60_000;

/**
 * Avisa 5 minutos antes de a sessão expirar por inatividade e oferece continuar.
 * Evita que o profissional perca o que está digitando sem saber por quê.
 */
export function AvisoInatividade() {
  const { atualizar, sair } = useSessao();
  const [restanteMs, setRestanteMs] = useState<number | null>(null);

  useEffect(() => {
    const verificar = () => {
      const restante = INATIVIDADE_MS - (Date.now() - momentoUltimaAtividade());
      if (restante <= 0) void sair();
      setRestanteMs(restante <= AVISAR_ANTES_MS ? Math.max(restante, 0) : null);
    };
    const intervalo = window.setInterval(verificar, 15_000);
    return () => window.clearInterval(intervalo);
  }, [sair]);

  if (restanteMs === null) return null;
  const minutos = Math.max(1, Math.ceil(restanteMs / 60_000));

  return (
    <div
      role="alertdialog"
      aria-labelledby="aviso-inatividade-titulo"
      aria-describedby="aviso-inatividade-texto"
      className="fixed inset-x-4 bottom-4 z-50 mx-auto flex max-w-lg flex-col gap-3 rounded-xl border border-alerta/40 bg-superficie p-4 shadow-xl sm:flex-row sm:items-center"
    >
      <Clock className="size-6 shrink-0 text-alerta" aria-hidden="true" />
      <div className="flex-1">
        <p id="aviso-inatividade-titulo" className="font-semibold text-texto">
          Sua sessão vai expirar
        </p>
        <p id="aviso-inatividade-texto" className="text-sm text-texto-suave">
          {`Sem atividade, você sairá em cerca de ${minutos} min.`}
        </p>
      </div>
      <Botao
        autoFocus
        onClick={async () => {
          await atualizar();
          setRestanteMs(null);
        }}
      >
        Continuar conectado
      </Botao>
    </div>
  );
}
